/* Auto-generated, do not edit */
import React from 'react';

interface Props {
  size?: number | string;
  width?: number | string;
  height?: number | string;
  fill?: string;
}

function Avatar_icn_avatar17(props: Props) {
    const { size = 14, width = size, height = size, fill = '' } = props;
    return (
      <svg viewBox="0 0 24 24" fill="#27A2A8" width={ `${ width }px` } height={ `${ height }px` } ><path d="M4 10c0-4.4 3.6-8 8-8s8 3.6 8 8h2v4h-1.1c-.5 4.5-4.3 8-8.9 8s-8.4-3.5-8.9-8H2v-4h2z" opacity=".3"/><path d="M5 11h3v2H5zm11 0h3v2h-3zm-2 2h3v4h-3zm-4-2h4v3h-4zm-3 2h3v4H7zm4-5c0 1.1-.9 2-2 2s-2-.9-2-2h4zm6 0c0 1.1-.9 2-2 2s-2-.9-2-2h4z"/><path d="M12 23c-4.8 0-8.9-3.4-9.8-8H1V9h2.1c.5-4.5 4.3-8 8.9-8 4.6 0 8.4 3.5 8.9 8H23v6h-1.2c-.9 4.6-5 8-9.8 8zM3 13h1v.9C4.4 18 7.9 21 12 21s7.5-3.1 8-7.1V13h1v-2h-2v-1c0-3.9-3.1-7-7-7s-7 3.1-7 7v1H3v2z"/></svg>
  );
}

export default Avatar_icn_avatar17;
